<div class="h-full flex flex-col sidebar-content" *ngIf="property" [class.hidden]="currentView !== null">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="Pricing">
      <!-- Pricing -->
      <div class="p-4 flex flex-col gap-3">
        <sbnb-property-base-price
          *ngIf="property.counts?.airbnb > 0"
          [currency]="property.currency"
          [dynamicPricingEnabled]="
            property.dynamic_pricing?.outbound_dynamic_pricing_enabled
          "></sbnb-property-base-price>
        <sbnb-step-trigger
          headline="Dynamic Pricing"
          [subline]="$dynamicPricingOn() ? 'Adjust your setup' : (dynamicPricingSidebarSubtitle$ | async)"
          (click)="setViewDynamicPricing()"
          [new]="!$dynamicPricingOn()"
          [on]="$dynamicPricingOn()"
          [emphasize]="!$dynamicPricingOn()"></sbnb-step-trigger>

        <sbnb-alert-card
          context="negative"
          *sbnbCSDebug="!!$dynamicPricingErrors() || $dynamicPricingOutOfMarket()"
          class="flex flex-col gap-1">
          <strong>Dynamic pricing can't be enabled:</strong>

          <ng-container *ngIf="$dynamicPricingErrors()">
            <div *ngFor="let error of $dynamicPricingErrors() | keyvalue" class="text-xs">
              {{ error.value }}
            </div>
          </ng-container>

          <div *ngIf="$dynamicPricingOutOfMarket()" class="text-xs">
            This property is out of market.
            <a href="https://www.usewheelhouse.com/markets" target="_blank" class="link-grape">See supported markets</a>
          </div>
        </sbnb-alert-card>

        <sbnb-step-trigger
          headline="Listing markups"
          [subline]="listingMarkupsSubline$ | async"
          (click)="setView(viewEnum.LISTING_MARKUPS)"></sbnb-step-trigger>
        <!-- This subline is acting as a proxy for conditionally showing the step trigger, it's not always relevant to the property -->
        <sbnb-step-trigger
          *ngIf="primaryRatePlanSubline$ | async as subline"
          headline="Primary rate plan"
          [subline]="subline"
          (click)="setView(viewEnum.PRIMARY_RATE_PLAN)"></sbnb-step-trigger>
        <sbnb-step-trigger
          headline="Security deposit"
          [subline]="securityDepositSubline$ | async"
          (click)="setView(viewEnum.SECURITY_DEPOSIT)"></sbnb-step-trigger>
        <sbnb-step-trigger
          headline="Occupancy based"
          [subline]="occupancyBasedSubline$ | async"
          (click)="setView(viewEnum.OCCUPANCY_BASED)"></sbnb-step-trigger>
        <sbnb-step-trigger
          headline="Fees"
          [subline]="feesSubline$ | async"
          (click)="setView(viewEnum.FEES)"></sbnb-step-trigger>
        <sbnb-step-trigger
          headline="Discounts"
          [subline]="discountSubline$ | async"
          (click)="setView(viewEnum.DISCOUNTS)"></sbnb-step-trigger>
      </div>
    </mat-tab>
    <mat-tab label="Availability" *ngIf="canViewAvailabilityRules$ | async">
      <div class="p-4 h-full">
        <h3>Availability rules</h3>
        <p class="m-0 mb-4">Set when your property is bookable.</p>
        <sbnb-property-availability-rules-form
          [property]="property"
          (saved)="refreshCalendar.emit()"></sbnb-property-availability-rules-form>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<div id="dynamic-pricing" class="pt-6 h-full sidebar-content" *ngIf="currentView === viewEnum.DYNAMIC_PRICING">
  <sbnb-sidebar-property-dynamic-pricing
    (hide)="currentView = undefined"
    [property]="property"></sbnb-sidebar-property-dynamic-pricing>
</div>

<div class="h-full sidebar-content" [class.hidden]="!currentView || currentView === viewEnum.DYNAMIC_PRICING">
  <div class="h-full flex flex-col">
    <div class="flex-1 flex flex-col gap-6 p-4">
      <div class="flex items-center gap-1 mb-3 cursor-pointer" (click)="goBack()">
        <sbnb-icon icon="small-arrow-left" [size]="14"></sbnb-icon>
        <div class="text-sm m-0">Property pricing</div>
      </div>

      <sbnb-property-listing-markups
        *ngIf="currentView === viewEnum.LISTING_MARKUPS"
        [propertyListings]="property.listings"></sbnb-property-listing-markups>
      <sbnb-property-booking-rate-plans
        *ngIf="currentView === viewEnum.PRIMARY_RATE_PLAN"
        [propertyId]="property.id"
        [propertyCurrency]="property.currency"
        [propertyName]="property.name"></sbnb-property-booking-rate-plans>
      <sbnb-property-fees-taxes-discounts
        *ngIf="
          currentView === viewEnum.SECURITY_DEPOSIT ||
          currentView === viewEnum.OCCUPANCY_BASED ||
          currentView === viewEnum.FEES ||
          currentView === viewEnum.DISCOUNTS
        "
        [property]="property"
        [section]="currentView"></sbnb-property-fees-taxes-discounts>
    </div>
  </div>
</div>
